// extracted by mini-css-extract-plugin
export default {"imageContainer":"H_-z","summaryPar":"I_-z","ratingCategories":"J_-z","reviewerInfo":"K_-z","reviewTypes":"L_-z","expanded":"M_-z"};